import { CookieUsable } from 'infrastructure/storages/CookieUsable';
import type Cookies from 'js-cookie';
import { ICookieUsable } from 'interfaceAdapter/gatewaySchemas/ICookieUsable';
import { ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';

const KEY = 'supporter_token';
const PREFIX = 'ma_';
const EXPIRES = 14;

export class SupportUserTokenRepository implements ISupportUserTokenRepository {
    constructor(private readonly storage: ICookieUsable = new CookieUsable(PREFIX, KEY)) {
        this.defaultOptions = {
            ...this.defaultOptions,
            // 現状開発環境では HTTP なので Cookie をセキュア縛りにすることはできない
            secure: !(import.meta.env.DEV || import.meta.env.VITE_APP_URL === 'http://debug.local'),
        };
    }

    private defaultOptions = {
        sameSite: 'Lax',
        path: '/',
    } as Cookies.CookieAttributes;

    public get() {
        return this.storage.get();
    }

    public set(token: string) {
        const expires = new Date();
        expires.setDate(expires.getDate() + EXPIRES);

        const options = {
            ...this.defaultOptions,
            expires,
        } as Cookies.CookieAttributes;

        this.storage.set(token, options);
    }

    public remove() {
        this.storage.remove(this.defaultOptions);
    }
}
